
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `แตะ "เปิดในเบราว์เซอร์..."`,
's182ab2d6c997515f': `เพิ่มไปยังหน้าจอโฮมของคุณ เพื่อประสบการณ์ที่ครบถ้วนและเข้าถึงได้ง่าย`,
's224cbcec014ef6b5': `กด "แชร์" ในแถบนำทาง`,
's233af3b7eb5e0364': `เพิ่มไปยังหน้าหลัก`,
's37a9e8aec5713460': `เพิ่มเติม`,
's4c3161035f3a1413': `กด "เมนู"`,
's4e1e10a6ca408245': `แตะ "เพิ่มไปยังหน้าจอโฮม"`,
's6196153c4b0c1ea0': `ติดตั้ง`,
's633502f7cff4f847': `เปิดเมนูของเบราว์เซอร์`,
's681e399d63311fba': `ดูภาพตัวอย่าง`,
's6d14a4f70ba4e3cf': `กด "เมนู" หากไม่มีไอคอนแชร์`,
's922329d6f6213590': `เพิ่มไปยัง Dock`,
's9c63a79ffcc2a3a3': `กด "เพิ่มไปยังหน้าจอโฮม"`,
'sa2d71bfd9525168d': `กด "เพิ่มไปยัง Dock"`,
'sa5ef80b4bb9b39f8': `ย่อ`,
'sb527eca1c1d7e7be': `เปิดเมนูเบราว์เซอร์ในแอป`,
'sba52286c21552a4e': `ติดตั้งลงในอุปกรณ์ของคุณ เพื่อประสบการณ์ที่ครบถ้วนและเข้าถึงได้ง่าย`,
'sc16e00a7a8b2fde2': `ย้อนกลับ`,
'scdaf4bbff76674c8': `เพิ่มไปยังหน้าจอโฮม`,
'sd18a5b85f599ff3c': `เปิดลิงก์ที่คัดลอกใน Safari`,
'se72fc3a84f9b51c3': `แตะที่นี่เพื่อคัดลอกลิงก์แอป`,
'se740f75b95a51807': `เพิ่มไปยัง Dock ของคุณ เพื่อประสบการณ์ที่ครบถ้วนและเข้าถึงได้ง่าย`,
'sfa6c42cdf48d93d2': `แต่เบราว์เซอร์นี้ไม่รองรับฟังก์ชันนี้ โปรดเปิดลิงก์ในเบราว์เซอร์ภายนอกเพื่อดำเนินการต่อ`,
'sfb78526365796a41': `กด "ดูเพิ่มเติม" ในเมนูแชร์`,
'sfea652f6580ff086': `เว็บไซต์นี้ใช้งานได้เหมือนแอป`,
    };
  